import { EventTypes } from "../eventtype.model";
import React, { useState, useEffect } from "react";
import "moment-timezone";
import moment from "moment";
import { mkConfig, generateCsv, download } from "export-to-csv";
// import moment from "moment";
const headers: any = [
  { label: "Event Name", key: "event_name" },
  { label: "Event Count", key: "value" },
  { label: "% Change", key: "change" },
];
const key: string = "event_name";

export const dataComparator = (startdateRange: any, endDateRange: any) => {
  let startEventsData: any = [];

  startdateRange.forEach((row: any) => {
    const dataCompareObj = endDateRange.find((keyelement: any) =>
      Object.keys(row)
        .filter((k) => k !== "value")
        .every((k) => row[k] === keyelement[k])
    );

    let initialValue = row.value;
    initialValue = initialValue.toString().replace(/[,$]/g, "");

    let finalValue = 0;

    if (dataCompareObj) finalValue = dataCompareObj.value;

    const perChange = ((initialValue - finalValue) / finalValue) * 100;

    const obj = { ...row, change: isNaN(perChange) ? "--" : perChange };

    startEventsData.push(obj);
  });

  return startEventsData;
};

export const getCuralateDataBySession = (sessions: any, sessionids: any) => {
  const eventsData: any = [];

  sessions.forEach((obj: any) => {
    const sessionid = obj.session_id;
    const sessionobj: any = sessionids.find(
      (session: any) => session.sessionid === sessionid
    );
    const count = sessionobj ? sessionobj.count : 0;
    obj["event_timestamp"] = moment(obj["event_timestamp"] / 1000)
      .tz("America/Los_Angeles")
      .format("MM-DD-YYYY hh:mm:ss A");
    eventsData.push({ ...obj, item_requests: count });
  });
  console.log(eventsData);
  return eventsData;
};

export const getSummary = (data: any, EventTypes: EventTypes[]) => {
  const startData: any = {};

  const EventsData: any = [];

  EventTypes.forEach((eventobj: any) => {
    const eventname = eventobj.name;
    startData[eventname] = 0;
  });

  data.forEach((row: any) => {
    const eventname = row.event_name;
    const eventvalue = row.value;

    let eventobj: any = EventTypes.find((eventtype: any) =>
      eventtype.events.includes(eventname)
    );

    if (eventobj) startData[eventobj.name] += parseInt(eventvalue);
  });

  Object.keys(startData).forEach((element: any) => {
    let eventobj: any = EventTypes.find(
      (eventtype: any) => element === eventtype.name
    );
    if (eventobj) {
      const obj = {
        event_name: eventobj.label,
        value: startData[element],
      };

      EventsData.push(obj);
    }
  });

  return EventsData;
};

export const getComparisonSummary = (
  startdateRange: any,
  endDateRange: any,
  EventTypes: EventTypes[]
) => {
  const startData: any = {};
  const endData: any = {};
  const finalEventsData: any = {};

  //  console.log(KJEventTypes)

  EventTypes.forEach((eventobj: any) => {
    const eventname = eventobj.name;
    startData[eventname] = 0;
    endData[eventname] = 0;
  });

  startdateRange.forEach((row: any) => {
    const eventname = row.event_name;
    const eventvalue = row.value;
    let eventobj: any = EventTypes.filter((eventtype: any) =>
      eventtype.events.includes(eventname)
    );
    eventobj.forEach((val: any) => {
      if (eventobj) startData[val.name] += parseInt(eventvalue);
    });
  });

  endDateRange.forEach((row: any) => {
    const eventname = row.event_name;
    const eventvalue = row.value;

    let eventobj: any = EventTypes.filter((eventtype: any) =>
      eventtype.events.includes(eventname)
    );
    eventobj.forEach((val: any) => {
      if (eventobj) endData[val.name] += parseInt(eventvalue);
    });
  });

  finalEventsData["start"] = [];

  Object.keys(startData).forEach((element: any) => {
    let eventobj: any = EventTypes.find(
      (eventtype: any) => element === eventtype.name
    );
    if (eventobj) {
      const obj = {
        event_name: eventobj.label,
        value: startData[element],
      };

      finalEventsData["start"].push(obj);
    }
  });

  finalEventsData["end"] = [];

  Object.keys(endData).forEach((element: any) => {
    let eventobj: any = EventTypes.find(
      (eventtype: any) => element === eventtype.name
    );
    if (eventobj) {
      const obj = {
        event_name: eventobj.label,
        value: endData[element],
      };

      finalEventsData["end"].push(obj);
    }
  });

  return finalEventsData;
};

// export const getComparisonBySummary = (startdateRange: any, endDateRange: any) => {

//   let startEventsData : any = {};
//   let endEventsData : any = {};
//   const finalEventsData :any = {};

//   let stores : any = []

//   startdateRange.forEach((row: any) => {

//     let eventname = row.event_name;
//     let eventvalue = row.value;

//     eventname in startEventsData ?
//     startEventsData[eventname] += parseInt(eventvalue) :
//     startEventsData[eventname] = parseInt(eventvalue);

//     stores.push(row.storeName)

//   });

//   endDateRange.forEach((row: any) => {

//     let eventname = row.event_name;
//     let eventvalue = row.value;

//     eventname in endEventsData ?
//     endEventsData[eventname] += parseInt(eventvalue) :
//     endEventsData[eventname] = parseInt(eventvalue);

//   });

//   stores = stores.filter((x : any, i: any, a: any) => a.indexOf(x) === i)

//   finalEventsData['start'] = []

//   Object.keys(startEventsData).forEach((element: any) => {
//     let eventobj: any = Events.find((eventtype : any) => element === eventtype.name)
//     if(eventobj)
//     {
//       const obj = {
//         'event_name': eventobj.label,
//         'value': startEventsData[element]
//       }

//       finalEventsData['start'].push(obj);
//     }
//   })

//   finalEventsData['end'] = []

//   Object.keys(endEventsData).forEach((element: any) => {
//     let eventobj: any = Events.find((eventtype : any) => element === eventtype.name)
//     if(eventobj)
//     {
//       const obj = {
//         'event_name': eventobj.label,
//         'value': endEventsData[element]
//       }

//       finalEventsData['end'].push(obj);
//     }
//   })

//   finalEventsData['stores'] = [...stores];

//   return finalEventsData;

// }

export const getComparisonData1 = (startdateRange: any, endDateRange: any) => {
  let startEventsData: any = {};
  let endEventsData: any = {};
  const finalEventsData: any = {};

  startdateRange.forEach((row: any) => {
    let keyvalue = row[key];
    let countValue = row["value"];

    if (countValue && keyvalue && startEventsData[keyvalue])
      startEventsData[keyvalue]["value"] += countValue;
    else if (keyvalue) startEventsData[keyvalue] = row;

    if (keyvalue) finalEventsData[keyvalue] = startEventsData[keyvalue];
  });

  endDateRange.forEach((row: any) => {
    let keyvalue = row[key];
    let countValue = row["value"];

    if (countValue && keyvalue && endEventsData[keyvalue])
      endEventsData[keyvalue]["value"] += countValue;
    else if (keyvalue) endEventsData[keyvalue] = row;
  });

  let allKeys = [
    ...Object.keys(startEventsData),
    ...Object.keys(endEventsData),
  ];

  allKeys = allKeys.filter((x: any, i: any, a: any) => a.indexOf(x) === i);

  allKeys.forEach((key: any) => {
    let initialValue, finalValue;

    startEventsData[key]
      ? (initialValue = startEventsData[key]["value"])
      : (initialValue = 0);
    endEventsData[key]
      ? (finalValue = endEventsData[key]["value"])
      : (finalValue = 0);

    const perChange = ((initialValue - finalValue) / finalValue) * 100;

    if (finalEventsData[key]) finalEventsData[key]["change"] = perChange;
  });

  console.log("In Comparison 1 finalEventsData===>", finalEventsData);
};

export const getComparisonData = (startdateRange: any, endDateRange: any) => {
  let startEventsData: any = {};

  let startEventsData1: any = {};

  let endEventsData: any = {};

  const finalEventsData: any = {};

  const finalEventsData1: any = {};

  console.log("startEventsData1", startEventsData1);

  startdateRange.forEach((row: any) => {
    const obj: any = {};

    let keyvalue;
    let countValue;

    headers.forEach((headerrow: any) => {
      const headerkey = headerrow.key;
      obj[headerkey] = row[headerkey];

      if (headerkey === key) keyvalue = row[headerkey];

      if (headerkey === "value") countValue = row[headerkey];
    });

    if (countValue && keyvalue && startEventsData[keyvalue])
      startEventsData[keyvalue]["value"] += countValue;
    else if (keyvalue) startEventsData[keyvalue] = obj;

    if (keyvalue) finalEventsData[keyvalue] = startEventsData[keyvalue];
  });

  endDateRange.forEach((row: any) => {
    const obj: any = {};

    let keyvalue;
    let countValue;

    headers.forEach((headerrow: any) => {
      const headerkey = headerrow.key;
      obj[headerkey] = row[headerkey];

      if (headerkey === key) keyvalue = row[headerkey];

      if (headerkey === "value") countValue = row[headerkey];
    });

    if (countValue && keyvalue && endEventsData[keyvalue])
      endEventsData[keyvalue]["value"] += countValue;
    else if (keyvalue) endEventsData[keyvalue] = obj;
  });

  let allKeys = [
    ...Object.keys(startEventsData),
    ...Object.keys(endEventsData),
  ];

  allKeys = allKeys.filter((x: any, i: any, a: any) => a.indexOf(x) === i);

  allKeys.forEach((key: any) => {
    let initialValue, finalValue;

    startEventsData[key]
      ? (initialValue = startEventsData[key]["value"])
      : (initialValue = 0);
    endEventsData[key]
      ? (finalValue = endEventsData[key]["value"])
      : (finalValue = 0);

    const perChange = ((initialValue - finalValue) / finalValue) * 100;

    if (finalEventsData[key]) finalEventsData[key]["change"] = perChange;
  });

  console.log("In Comparison finalEventsData===>", finalEventsData);
};

export const downloadCSV = (data: any, fileName: string, headers: any) => {
  const options:any = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    showTitle: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: fileName,
    headers: headers,
  };
  const csvConfig = mkConfig(options);
  const csv = generateCsv(csvConfig)(data);
  download(csvConfig)(csv)
};
